import { render, staticRenderFns } from "./RegulatoryAffairs.vue?vue&type=template&id=458b986c&"
import script from "./RegulatoryAffairs.vue?vue&type=script&lang=js&"
export * from "./RegulatoryAffairs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports